<template>
    <tr :ref="'tr_' + index" :class="{ active: index == selected }">
        <td>{{ data.rule }}</td>
        <td>{{ data.days || '-' }}</td>
        <td>{{ amountComputed }}</td>
        <td>{{ toleranceComputed }}</td>
        <td>
            <ui-menu-card>
                <button type="button" @click="edit()">Editar</button>
                <button type="button" @click="remove()">Excluir</button>
            </ui-menu-card>
        </td>
    </tr>
</template>

<script>
	import { uiMenuCard } from '@/components/ui'

	export default {
		components: {
			uiMenuCard,
		},

		props: {
			data: {
				type: Object,
				required: false,
				default: () => {}
			},

			index: {
				type: String,
				required: false,
				default: ''
			},

			selected: {
				type: [String, Number],
				required: false,
				default: ''
			},
		},

		data: function () {
			return {}
		},

		computed: {
			amountComputed() {
				return this.data.amount ? parseFloat(this.data.amount).toFixed(2).replace('.', ',') : '-'
			},
			toleranceComputed() {
				return this.data.tolerance ? parseFloat(this.data.tolerance).toFixed(2).replace('.', ',') : '-'
			},
		},

		methods: {
			edit() {
				this.$emit('edit', { index: this.index, data: { ...this.data } })
			},

			remove() {
				this.$emit('remove', { index: this.index, id: this.data.id })
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
